import ExerciseStore from '../storage/ExerciseStore.js'

class ExercisesView extends HTMLElement {
  connectedCallback() {
    this.#render()
  }

  refresh() {
    this.#render()
  }


  #render() {
    const template = this.querySelector("template")

    const exercisesByType = ExerciseStore.getAllByType()

    this.removeAttribute("num-strength")
    this.removeAttribute("num-stretch")
    this.removeAttribute("num-cardio")

    for(const [type,exercises] of Object.entries(exercisesByType)) {
      if (exercises.length > 0) {
        this.setAttribute(`num-${type}`,exercises.length)
        const section = document.getElementById(type)
        if (section) {
          const ul = section.querySelector("ul")
          ul.innerHTML = ""
          exercises.forEach( (exercise) => {
            const li = document.createElement("li")
            const node = template.content.cloneNode(true)
            const item = node.firstElementChild
            item.id = exercise.id
            item.setAttribute("laterality", exercise.laterality)
            item.setAttribute("measure", exercise.measure)
            item.setAttribute("exercise-type", exercise.exerciseType)
            item.querySelector("slot[name='exerciseName']").textContent = exercise.exerciseName
            item.querySelector("slot[name='value']").textContent = exercise.value
            item.querySelector("slot[name='valueLeft']").textContent = exercise.valueLeft
            item.querySelector("slot[name='valueRight']").textContent = exercise.valueRight
            let setsText = ""
            if (exercise.sets !== undefined) {
              if (exercise.sets === 1) {
                setsText = "1 set"
              }
              else {
                setsText = `${exercise.sets} sets`
              }
            }
            item.querySelector("slot[name='sets']").textContent = setsText
            item.addEventListener("gime-delete-exercise", () => this.refresh())
            li.appendChild(node)
            ul.appendChild(li)
          })
        }
      }
    }
  }
}

export default ExercisesView
